import { Component, OnInit, HostListener } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { ApprovalService } from '../../services/approval.service';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  menus: any = [
    {
      id: 0,
      title: 'Dashboard',
      url: '/fox-admin',
      icon: 'home',
      selected: false,
    },
    {
      id: 1,
      title: 'Tin đăng',
      url: '/fox-admin/listing',
      icon: 'profile',
      selected: false,
    },
    {
      id: 2,
      title: 'Báo cáo & Chat',
      url: '/fox-admin/report',
      icon: 'flag',
      selected: false,
    },
    {
      id: 12,
      title: 'Đánh giá',
      url: '/fox-admin/review',
      icon: 'star',
      selected: false,
    },
    {
      id: 11,
      title: 'Banner trang chủ',
      url: '/fox-admin/banner',
      icon: 'layout',
      selected: false,
    },
    {
      id: 9,
      title: 'Bảng xếp hạng',
      url: '/bang-xep-hang',
      icon: 'trophy',
      selected: false,
      external: true,
    },
    {
      id: 10,
      title: 'Giải đấu',
      url: '/giai-dau',
      icon: 'flag',
      selected: false,
      external: true,
    },
    {
      id: 3,
      title: 'Quản lý',
      url: '/fox-admin/settings',
      icon: 'setting',
      selected: false,
      openSubMenu: true,
      children: [
        { id: 31, title: 'Tài khoản',   url: '/fox-admin/settings/user',        icon: 'user',     selected: false },
        { id: 38, title: 'Danh mục',    url: '/fox-admin/settings/category',    icon: 'appstore', selected: false },
        { id: 40, title: 'Hãng',        url: '/fox-admin/settings/brand',       icon: 'apartment', selected: false },
        { id: 37, title: 'CLB',         url: '/fox-admin/settings/clb-account', icon: 'team',     selected: false },
        { id: 13, title: 'Log hoạt động', url: '/fox-admin/activity-log',       icon: 'history',  selected: false },
      ],
    },
  ];

  menuSelected: any = {};
  collapse = false;
  recalculation: any = {};

  isMobileView = window.innerWidth <= 768;
  drawerVisible = false;

  @HostListener('window:resize')
  onResize() {
    this.isMobileView = window.innerWidth <= 768;
  }

  constructor(
    private approvalService: ApprovalService,
    private router: Router,
    private auth: AngularFireAuth
  ) {
    this.auth.authState.subscribe(async (authUser) => {
      if (authUser) {
        this.recalculation = true;
      } else {
        this.router.navigate(['/fox-admin/login']);
      }
    });
  }

  ngOnInit(): void {
    this.menus = this.getMenuByRole();
    const currentUrl = this.router.url.split('?')[0];

    // Dashboard (đúng path /fox-admin)
    if (currentUrl === '/fox-admin' || currentUrl === '/fox-admin/') {
      this.menus[0].selected = true;
      this.approvalService.updateMenu(this.menus[0]);
      this.approvalService.updateShowIcon(false);
      return;
    }

    this.menus.forEach((item: any, index: any) => {
      this.menus[index].selected = false;
      // Bỏ qua Dashboard để tránh khớp với mọi path con của /fox-admin
      if (item.url === '/fox-admin') {
        return;
      }
      if (currentUrl === item.url || currentUrl.startsWith(item.url + '/')) {
        this.approvalService.updateMenu(item);
        this.menus[index].selected = true;
      }
    });
  }

  ngAfterViewInit() {
    this.approvalService.currentApprovalStageMenu.subscribe(x => {
      setTimeout(() => { this.menuSelected = x; }, 0);
    });
  }

  isMobile(): boolean {
    return this.isMobileView;
  }

  openDrawer() {
    this.drawerVisible = true;
  }

  closeDrawer() {
    this.drawerVisible = false;
  }

  navigateMobile(item: any, isSubmenu = false) {
    this.menuSelected = item;
    this.approvalService.updateMenu(item);
    this.approvalService.updateShowIcon(false);
    localStorage.removeItem('parentRouting');
    this.closeDrawer();
    this.router.navigate([item.url]);
  }

  checkRouter(itemMenu: any, isSubmenu: boolean) {
    this.menuSelected = itemMenu;
    this.approvalService.updateShowIcon(false);
    this.approvalService.updateMenu(itemMenu);
    localStorage.removeItem('parentRouting');
    if (!isSubmenu) {
      this.openSubHandler(itemMenu);
    }
  }

  openSubHandler(itemMenu: any) {
    for (let index = 0; index < this.menus.length; index++) {
      const menu = this.menus[index];
      if (menu.children) {
        this.menus[index].openSubMenu = true;
        if (menu.id === itemMenu.id) {
          this.menus[index].openSubMenu = true;
        }
      }
    }
  }

  getMenuByRole() {
    let datas = this.getData(this.menus);
    return datas.map((item: any) =>
      item.children
        ? { ...item, children: this.getData(item.children) }
        : { ...item }
    );
  }

  getData(datas: any) {
    return datas;
  }

  changeCollapse() {
    this.collapse = !this.collapse;
  }
}
